import { createSelector } from 'reselect';

import { tipSelector } from 'redux/modules/cart/selectors';

const tipTypeSelector = createSelector([tipSelector], tipValue =>
  tipValue < 0.01 ? 'percentage' : 'amount',
);

export default tipTypeSelector;
